/* Modern blog listing template — behaviour
 *
 * Deferred, dependency-free, idempotent.
 *
 * Handles:
 *   - topic strip horizontal scroll arrows   [data-mb-topic-scroll]
 *   - optional client-side topic filtering    [data-mb-topic] (only in the
 *     topic bar's "This page only" mode; the default mode uses real tag URLs
 *     and needs no JavaScript at all)
 */
(function () {
  'use strict';

  if (window.__mbListingInit) return;
  window.__mbListingInit = true;

  function initTopicScroll() {
    var arrows = document.querySelectorAll('[data-mb-topic-scroll]');
    if (!arrows.length) return;

    Array.prototype.forEach.call(arrows, function (arrow) {
      arrow.addEventListener('click', function () {
        var listId = arrow.getAttribute('aria-controls');
        var list = listId ? document.getElementById(listId) : document.querySelector('[data-mb-topic-list]');
        if (!list) return;
        var step = Math.max(120, Math.round(list.clientWidth * 0.7));
        list.scrollBy({ left: Number(arrow.getAttribute('data-mb-topic-scroll')) * step, behavior: 'smooth' });
      });
    });
  }

  function initTopicFilter() {
    var buttons = document.querySelectorAll('button[data-mb-topic]');
    if (!buttons.length) return;

    var grid = document.querySelector('[data-mb-article-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.mb-article-card'));
    var empty = document.querySelector('[data-mb-no-results]');
    var count = document.querySelector('[data-mb-result-count]');
    var countTemplate = count ? count.textContent.trim() : '';
    var topic = 'all';

    function apply() {
      var visible = 0;

      cards.forEach(function (card) {
        var topics = (card.getAttribute('data-mb-topics') || '').split(/\s+/);
        var show = topic === 'all' || topics.indexOf(topic) !== -1;
        card.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;

      if (count) {
        if (topic === 'all') {
          count.textContent = countTemplate;
        } else {
          count.textContent = visible + (visible === 1 ? ' result' : ' results') + ' on this page';
        }
      }
    }

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () {
        topic = button.getAttribute('data-mb-topic') || 'all';
        Array.prototype.forEach.call(buttons, function (other) {
          other.setAttribute('aria-pressed', String(other === button));
        });
        apply();
      });
    });

    apply();
  }

  /* Arrows are only useful when the strip actually overflows, so flag that on the
     nav and let CSS show/hide them. Re-checked on resize and after fonts load,
     since both change the measured width. */
  function initTopicOverflow() {
    var navs = document.querySelectorAll('[data-mb-topic-nav]');
    if (!navs.length) return;

    function measure() {
      Array.prototype.forEach.call(navs, function (nav) {
        var list = nav.querySelector('[data-mb-topic-list]');
        if (!list) return;
        var overflows = list.scrollWidth - list.clientWidth > 2;
        nav.setAttribute('data-mb-overflow', String(overflows));
      });
    }

    measure();
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  function init() {
    initTopicScroll();
    initTopicOverflow();
    initTopicFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.mb-root')) {
      init();
    }
  });
})();
